import '@/components/loading-sticks/loading-sticks.css';

export default function LoadingSticks() {
  return (
    <svg viewBox='0 0 24 30' className='loading-sticks'>
      <rect x='0' y='10' className='loading-sticks__rect'>
        <animate
          attributeName='opacity'
          attributeType='XML'
          values='0.2; 1; .2'
          begin='0s'
          dur='0.6s'
          repeatCount='indefinite'
        />
        <animate
          attributeName='height'
          attributeType='XML'
          values='10; 20; 10'
          begin='0s'
          dur='0.6s'
          repeatCount='indefinite'
        />
        <animate
          attributeName='y'
          attributeType='XML'
          values='10; 5; 10'
          begin='0s'
          dur='0.6s'
          repeatCount='indefinite'
        />
      </rect>
      <rect x='8' y='10' className='loading-sticks__rect'>
        <animate
          attributeName='opacity'
          attributeType='XML'
          values='0.2; 1; .2'
          begin='0.15s'
          dur='0.6s'
          repeatCount='indefinite'
        />
        <animate
          attributeName='height'
          attributeType='XML'
          values='10; 20; 10'
          begin='0.15s'
          dur='0.6s'
          repeatCount='indefinite'
        />
        <animate
          attributeName='y'
          attributeType='XML'
          values='10; 5; 10'
          begin='0.15s'
          dur='0.6s'
          repeatCount='indefinite'
        />
      </rect>
      <rect x='16' y='10' className='loading-sticks__rect'>
        <animate
          attributeName='opacity'
          attributeType='XML'
          values='0.2; 1; .2'
          begin='0.3s'
          dur='0.6s'
          repeatCount='indefinite'
        />
        <animate
          attributeName='height'
          attributeType='XML'
          values='10; 20; 10'
          begin='0.3s'
          dur='0.6s'
          repeatCount='indefinite'
        />
        <animate
          attributeName='y'
          attributeType='XML'
          values='10; 5; 10'
          begin='0.3s'
          dur='0.6s'
          repeatCount='indefinite'
        />
      </rect>
    </svg>
  );
}
